import React, { StrictMode, useEffect, useMemo, useRef, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import './App.scss';
import { ApolloProvider } from '@apollo/client';
import client from './appolloClient';
import Nav from './pages/Landing/Components/Personal/Nav';
import Footer from './pages/Landing/Components/Personal/Footer';
import axios, { AxiosError } from 'axios';
import { WhatsappIconExpandable } from './components/WhatsappExpandable';
import { getAppId } from './utils/getBaseURL';

axios.defaults.headers.common['ApplicationId'] = getAppId() || '';
axios.interceptors.response.use((response) => {
  return response;
}, function (error: AxiosError) {
  if (error?.response?.status === 401) {
    localStorage.removeItem('tazat');
    window.location.href = '/';
  }
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, config } = error.response;
      const method = config?.method?.toUpperCase();

      if (status === 403) {
        let message = "You are not authorised to carry out this action.";

        switch (method) {
          case "GET":
            message = "You are not authorised to view this resource.";
            break;
          default:
            message = "You are not authorised to carry out this action.";
        }
        toast.error(message); 
      }
    }
    return Promise.reject(error);
  }
);

export const AuthContext = React.createContext({
  isAuthenticated: false,
  setIsAuthenticated: () => { }
});

export const ProfileContext = React.createContext({
  profile: {},
  setProfile: () => { }
});

export const openWhatsapp = () => {
  window.open("https://wa.me/2349044556688?text=Hello%20Pensphere%20");
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profile, setProfile] = useState({});
  // const [_, showInAppInstallPromotion] = useState(false);
  const value = useMemo(
    () => ({ isAuthenticated, setIsAuthenticated }),
    [isAuthenticated]
  );

  const deferredPrompt = useRef();

  const profileValue = useMemo(
    () => ({ profile, setProfile }),
    [profile]
  );

  // useEffect(() => {
  //   window.addEventListener('beforeinstallprompt', (e) => {
  //     // Prevents the default mini-infobar or install dialog from appearing on mobile
  //     e.preventDefault();
  //     // Save the event because you'll need to trigger it later.
  //     deferredPrompt.current = e;
  //     // Show your customized install prompt for your PWA
  //     // Your own UI doesn't have to be a single element, you
  //     // can have buttons in different locations, or wait to prompt
  //     // as part of a critical journey.
  //     showInAppInstallPromotion(true);
  //   });
  // }, []);

  // const handleInstall = () => {
  //   // @ts-ignore
  //   deferredPrompt.current?.prompt();
  //   showInAppInstallPromotion(false);
  // }

  return (
    <StrictMode>
      {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore */}

      <AuthContext.Provider value={value}>
        <ApolloProvider client={client}>
          {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
          <ProfileContext.Provider value={profileValue}>
            <BrowserRouter>
              <div className="app relative">
                <Nav />
                <Toaster
                  position="top-center"
                  reverseOrder={false}
                />
                <Routes />
                <Footer />
                <WhatsappIconExpandable />
              </div>
            </BrowserRouter>
          </ProfileContext.Provider>
        </ApolloProvider>
      </AuthContext.Provider>
    </StrictMode>
  );
}

export default App;